
import React from 'react';
import { Mail, Phone, MapPin, Clock, Facebook, Instagram } from 'lucide-react';
import { companyInfo } from '../data';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <div className="pt-24 md:pt-40 pb-16">
      {/* Header */}
      <section className="bg-gray-50 py-20 border-b border-gray-100">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-[2.5rem] font-light text-gray-900 mb-6">Kontakt os</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Klar til at starte dit haveprojekt? Kontakt os i dag for en uforpligtende snak og et gratis tilbud.
          </p>
        </div>
      </section>

      <section className="py-24">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Info */}
            <div className="space-y-12">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-8">Kontakt information</h2>
                <div className="space-y-6">
                  <div className="flex items-start gap-5">
                    <div className="bg-green-100 p-4 rounded-2xl">
                      <Phone className="text-green-700" size={24} />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-1">Ring til os</p>
                      <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="text-xl font-bold text-gray-900 hover:text-green-700 transition-colors">
                        {companyInfo.phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-5">
                    <div className="bg-green-100 p-4 rounded-2xl">
                      <Mail className="text-green-700" size={24} />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-1">Send en email</p>
                      <a href={`mailto:${companyInfo.email}`} className="text-xl font-bold text-gray-900 hover:text-green-700 transition-colors break-all">
                        {companyInfo.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-5">
                    <div className="bg-green-100 p-4 rounded-2xl">
                      <MapPin className="text-green-700" size={24} />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-1">Besøg os</p>
                      <p className="text-xl font-bold text-gray-900">
                        {companyInfo.address}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-8 border-t border-gray-100">
                <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                  <Clock className="text-green-600" />
                  Åbningstider
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex justify-between">
                    <span>Mandag - Fredag:</span>
                    <span className="font-semibold">07:00 - 17:00</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Lørdag:</span>
                    <span className="font-semibold">Efter aftale</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Søndag:</span>
                    <span className="font-semibold">Lukket</span>
                  </li>
                </ul>
              </div>

              <div className="bg-[#1b4c2e] p-8 rounded-3xl text-white">
                <h3 className="text-xl font-bold mb-4">Følg os på sociale medier</h3>
                <p className="text-green-100 mb-6 text-sm">
                  Vi lægger jævnligt billeder op af vores seneste projekter. Følg med og få inspiration til din egen have.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a 
                    href={companyInfo.facebook} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-3 bg-white text-green-900 px-6 py-3 rounded-xl font-bold hover:bg-green-50 transition-colors text-sm flex-1 sm:flex-none"
                  >
                    <Facebook size={18} />
                    Facebook
                  </a>
                  <a 
                    href={companyInfo.instagram} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-3 bg-white text-green-900 px-6 py-3 rounded-xl font-bold hover:bg-green-50 transition-colors text-sm flex-1 sm:flex-none"
                  >
                    <Instagram size={18} />
                    Instagram
                  </a>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl border border-gray-100 relative">
              <div className="absolute top-0 right-0 p-4 -mt-6 -mr-6 hidden md:block">
                <div className="bg-green-600 text-white p-4 rounded-2xl shadow-xl rotate-12">
                  <span className="font-bold text-sm italic">Svar inden 24 timer</span>
                </div>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Send en besked</h2>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      {/* Map Placeholder or Area focus */}
      <section className="py-24 bg-gray-50 border-t border-gray-100">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Vi arbejder i hele Nordjylland</h2>
          <p className="text-gray-600">
            Fra Pandrup og Blokhus til Aalborg, Hjørring og Brønderslev. Kontakt os for at høre om vi kører i dit område.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Contact;
